import React from "react";
import "./GitHub.css";

export default function Github() {
  return (
    <p className="myName">
      <a href="https://github.com/Marines17/WeatherAppnew" target="blank">
        Open-source code
      </a>
      , by{" "}
      <a href="https://marinesimon.netlify.app/" target="blank">
        Marine Simon
      </a>
    </p>
  );
}
